import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { CategoryCatalog, StrapiListRequest, StrapiListResponse, StrapiResponse } from '@/interfaces/strapi';
import type { CategoryCatalogModel, StrapiResponseModel } from '@/interfaces/model';
import { catalogCategoriesListMapper } from '@/mappers';

export const getCatalogCategories = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiListResponse<CategoryCatalog>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/categorias-catalogos',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<CategoryCatalogModel>;
					return catalogCategoriesListMapper(json);
				},
			],
		}),
		controller,
	};
};
